"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const RecipeDetailWrapper = styled_components_1.default.div `
  height: 100%;
  background: #ffffff;
  overflow: auto;
  position: relative;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: revert;
    line-height: revert;
    font-size: revert;
  }
`;
const DocumentDetail = (props) => {
    (0, react_1.useEffect)(() => {
        const { head } = document;
        const link = document.createElement("link");
        if (head) {
            link.type = "text/css";
            link.rel = "stylesheet";
            link.href = props.recipeData.cssUrl;
            head.appendChild(link);
        }
        return () => {
            if (head) {
                head.removeChild(link);
            }
        };
    }, [props.recipeData.cssUrl]);
    return (react_1.default.createElement(RecipeDetailWrapper, null,
        react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                __html: props.recipeData.html,
            } })));
};
exports.default = DocumentDetail;
